import { render, staticRenderFns } from "./personDetailsContent.vue?vue&type=template&id=7d52b3c8&scoped=true"
import script from "./personDetailsContent.vue?vue&type=script&lang=js"
export * from "./personDetailsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d52b3c8",
  null
  
)

export default component.exports